<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30">
  	<div class="card bd-gray-400 tx-12">
  		<table class="table mg-b-0 table-contact bill data-table">
        <thead>
          <tr>
            <th>{{$t("transfer.内部ID")}}</th>
            <th>{{$t("transfer.国际快递单号")}}</th>
            <th>{{$t("transfer.操作人")}}</th>
            <th>{{$t("transfer.仓库名称")}}</th>
            <th>{{$t("transfer.扫描签收时间")}}</th>
            <th>{{$t("transfer.操作")}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in items" :key="item.id+index">
            <td class="valign-middle">
            	<span class="tx-white">{{item.packageId}}</span>
            </td>
            <td class="valign-middle">
            	<span class="tx-white">{{item.trackNumber}}</span>
            </td>
            <td class="valign-middle">
             	<span class="tx-white">{{item.subUserName == '' ? $t("transfer.主账号") : item.subUserName}}</span>
            </td>
            <td class="valign-middle">
              <span class="tx-white">{{item.address?item.address:'---'}}</span>
            </td>
            <td class="valign-middle">
              <span class="tx-white">{{item.timeCreated}}</span>
            </td>
            <td class="valign-middle">
            	<p class="mg-b-5">
            		<a href="javascript:;" class="tx-info mg-r-10" @click="print(item)">{{$t("transfer.打印条码")}}</a>
            		<a href="javascript:;" class="tx-info" @click="view(item)">{{$t("transfer.查看条码")}}</a>
            	</p>
            </td>
          </tr>
        </tbody>
        <tbody v-if="(!items || items.length < 1) && !first_loading">
          <tr>
            <td colspan="6">
              <div class="col-12 none-product">
                <i class="fa fa-ban"></i>{{$t("transfer.没有符合条件的数据")}}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  props: ["items", "first_loading"],
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
  },
  methods: {
  	print(item){
			this.$emit("print",item);
  	},
    view(item){
      localStorage.setItem("printSign",JSON.stringify(item));
      window.open("/print-sign.html")
    }
  }
};
</script>

